import { useState, useEffect } from 'react'
import { getProspectHistory } from '../services/api.js'

export function useProspectHistory(autoLoad = false) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [searches, setSearches] = useState([])

  const load = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await getProspectHistory()
      setSearches(data.searches || [])
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Erreur de chargement')
      setSearches([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (autoLoad) {
      load()
    }
  }, [autoLoad])

  return {
    loading,
    error,
    searches,
    load,
  }
}
